import {
    BASIC_LOT_DETAILS,
    PICKUP_ADDRESS,
    PICKUP_DETAILS,
    TITLE_DETAILS,
    SIGNATURE
} from '../constants';

  import BasicLotDetails from './BasicLotDetails';
  import PickupAddress from './PickupAddress';
  import PickupDetails from './PickupDetails';
  import Signature from './Signature';
  import TitleDetails from './TitleDetails';

  export default {
      [BASIC_LOT_DETAILS]: BasicLotDetails,
      [PICKUP_ADDRESS]: PickupAddress,
      [PICKUP_DETAILS]: PickupDetails,
      [SIGNATURE]: Signature,
      [TITLE_DETAILS]: TitleDetails
  };
  
  


// WEBPACK FOOTER //
// ./src/containers/PickupForm/steps/index.js